import { createStyles, Theme } from '@material-ui/core'

const sideHelpWidth = 500

export const styles = (theme: Theme) =>
  createStyles({
    cardHeader: {
      [theme && theme.breakpoints.down('sm')]: {
        width: '100%'
      },
      width: sideHelpWidth,
      zIndex: theme && theme.zIndex.drawer + 1,
      position: 'fixed',
      top: 0,
      right: 0,
      backgroundColor: '#ffffff',
      borderBottom: '1px solid #e0e0e0',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '14px'
    },
    cardHeaderTitleContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    cardContent: {
      height: '100%',
      margin: '94px 16px 0px 16px'
    },
    cardActions: {
      [theme && theme.breakpoints.down('sm')]: {
        width: '100%'
      },
      width: sideHelpWidth,
      position: 'fixed',
      top: 'auto',
      bottom: 0,
      backgroundColor: '#ffffff',
      borderTop: '1px solid #e0e0e0',
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '6px'
    },
    openInNewTabActionLink: {
      '&:hover': {
        textDecoration: 'none'
      }
    }
  })
